import { render, staticRenderFns } from "./AMEdit.vue?vue&type=template&id=f31b27bc&"
import script from "./AMEdit.vue?vue&type=script&lang=js&"
export * from "./AMEdit.vue?vue&type=script&lang=js&"
import style0 from "./AMEdit.vue?vue&type=style&index=0&id=f31b27bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports